module.exports = __webpack_public_path__ + "img/feiyin-client.168c26d1.png";